import ApiService from "@/api";
import { UserModel, ResponseModel } from "../models";
import {
  mapGetColorsResponse,
  mapGetEmployeesResponse,
  mapGetIconsResponse,
  mapGetOwnedUsersResponse,
} from "./AdapterServiceMappers";
import { IconColorType, IconType } from "tir-components";
import GetIconListRequest from "@/api/Main/dataSource/api/projects/groups/i-service/model/setting-icon/GetIconListRequest";
import PageRequest from "@/api/Main/dataSource/api/pagination-helper/lib/PageRequest";
import GetColorListRequest from "@/api/Main/dataSource/api/projects/groups/i-service/model/setting-color/GetColorListRequest";
import GetEmployeesListRequest from "@/api/Main/dataSource/api/projects/performers/i-service/model/request/GetEmployeesListRequest";
import OwnedUsersRequest from "@/api/Main/dataSource/api/projects/performers/i-service/model/request/OwnedUsersRequest";
import { CurrentUser, UserRoleEnum } from "tir-pm-user-core";
import EnumUserStatus from "@/api/Main/dataSource/api/users/base/enums/EnumUserStatus";

export class AdapterService {
  private readonly api = new ApiService();

  /**
   * * Получить иконки
   * @returns
   */
  getIcons() {
    return new Promise<ResponseModel<Array<IconType>>>(async (resolve) => {
      const result = new ResponseModel<Array<IconType>>();

      await this.api.Main.SettingIconService.getIconListAsync(
        new GetIconListRequest({ Page: new PageRequest({ Skip: 0, Take: 100 }) }),
      )
        .then((resp) => {
          result.Value = mapGetIconsResponse(resp);
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error("ERROR getIcons", e);
          return resolve(result);
        });
    });
  }

  /**
   * * Получить цвета иконок
   * @returns
   */
  getColors() {
    return new Promise<ResponseModel<Array<IconColorType>>>(async (resolve) => {
      const result = new ResponseModel<Array<IconColorType>>();

      await this.api.Main.SettingColorService.getColorListAsync(
        new GetColorListRequest({ Page: new PageRequest({ Skip: 0, Take: 100 }) }),
      )
        .then((resp) => {
          result.Value = mapGetColorsResponse(resp);
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error("ERROR getColors", e);
          return resolve(result);
        });
    });
  }

  /**
   * * Получить список пользователей и краткую информацыю о них
   * @returns
   */
  private getOwnedUsers() {
    return new Promise<ResponseModel<Array<UserModel>>>(async (resolve) => {
      const result = new ResponseModel<Array<UserModel>>();

      await this.api.Main.PerformersListService.getOwnedUsersAsync(
        new OwnedUsersRequest({ Page: new PageRequest({ Skip: 0, Take: 1000 }), Search: "", StatusList: [EnumUserStatus.Active] }),
      )
        .then((resp) => {
          result.Value = mapGetOwnedUsersResponse(resp);
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error("ERROR getOwnedUsers", e);
          return resolve(result);
        });
    });
  }

  /**
   * * Получить список сотрудников текущего пользователя
   * @returns
   */
  private getEmployeesForManagerList() {
    return new Promise<ResponseModel<Array<UserModel>>>(async (resolve) => {
      const result = new ResponseModel<Array<UserModel>>();

      await this.api.Main.EmployeeService.getEmployeesForManagerListAsync(
        new GetEmployeesListRequest({ Page: new PageRequest({ Skip: 0, Take: 1000 }), Statuses: [EnumUserStatus.Active] }),
      )
        .then((resp) => {
          result.Value = mapGetEmployeesResponse(resp);
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error("ERROR getEmployeesForManagerList", e);
          return resolve(result);
        });
    });
  }
  /**
   * * Получить список сотрудников текущего пользователя
   * @returns
   */
  getEmployees() {
    if (CurrentUser.Roles.includes(UserRoleEnum.Owner)) return this.getOwnedUsers();
    return this.getEmployeesForManagerList();
  }
}
